<template>
  <v-card outlined height="100%">
    <v-card-text class="ma-0 pa-0">
      <v-simple-table fixed-header dense height="calc(100vh - 470px)">
        <thead>
          <tr>
            <th>Name</th>
            <th>Kontoname</th>
            <th>IBAN</th>
            <th>BIC</th>
            <th>Bank</th>
            <th>Sepa-Einzug möglich</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, itemObjKey) in kassen" :key="itemObjKey" v-if="item !== 'kassen'">
            <td>{{ item.name }}</td>
            <td>{{ item.kontoname }}</td>
            <td>{{ item.IBAN }}</td>
            <td>{{ item.BIC }}</td>
            <td>{{ item.bank }}</td>
            <td>{{ item.sepa }}</td>
            <td><v-btn icon @click="(neueKasse = item) && (istNeu = false)"><v-icon>edit</v-icon></v-btn></td>
          </tr>
        </tbody>
      </v-simple-table> 
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      
      <v-row>
        <v-col cols="4"><v-text-field hide-details dense :disabled="!istNeu" hint="Der Name kann später nicht mehr geändert werden!" outlined label="Name" v-model="neueKasse.name"></v-text-field></v-col>
        <v-col cols="4"><v-text-field hide-details dense outlined label="Kontoname" v-model="neueKasse.kontoname"></v-text-field></v-col>
        <v-col cols="4"><v-text-field hide-details dense outlined label="Absender für Mails" v-model="neueKasse.absender"></v-text-field></v-col>
        <v-col cols="4"><v-select hide-details dense outlined :items="templates" label="Mailtemplate" v-model="neueKasse.template"></v-select></v-col>
        <v-col cols="4"><v-text-field hide-details dense outlined label="IBAN" v-model="neueKasse.IBAN" hint="ohne Leerzeichen"></v-text-field></v-col>
        <v-col cols="4"><v-text-field hide-details dense outlined label="BIC" v-model="neueKasse.BIC"></v-text-field></v-col>
        <v-col cols="4"><v-text-field hide-details dense outlined label="Bank" v-model="neueKasse.bank"></v-text-field></v-col>
        <v-col cols="4"><v-text-field hide-details dense outlined label="Gläubiger ID" v-model="neueKasse.glaubigerID"></v-text-field></v-col>
        <v-col cols="4"><v-checkbox on-icon="check_box" off-icon="check_box_outline_blank" v-model="neueKasse.sepa" label="Sepa-Einzug möglich"></v-checkbox></v-col>
        <v-col cols="6">
          <v-alert 
            border="bottom"
            color="accent"
            colored-border
            type="warning" 
            icon="warning">
            Einmal erstellte Kassen können nicht mehr umbenannt oder gelöscht werden!
          </v-alert>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn icon large @click="(neueKasse = []) && (istNeu = true)"><v-icon>settings_backup_restore</v-icon></v-btn>
          <v-btn icon class="primary" dark large @click="addKasse()"><v-icon>save</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        neueKasse: {},
        istNeu: true
      }
    },
    computed: {
      kassen () {
        return this.$store.getters['einstellungen/einstellung']('kassen')
      },
      templates () {
        const templates = this.$store.getters['einstellungen/einstellung']('templates').templates
        return templates.map(item => ({
          text: item.name,
          value: item.html
        }))
      }
    },
    methods: {
      addKasse () {
        if (
          (this.neueKasse.name) &&
          (this.neueKasse.kontoname) &&
          (this.neueKasse.IBAN) &&
          (this.neueKasse.BIC) &&
          (this.neueKasse.bank)
        ) {
          let kassen = this.$store.getters['einstellungen/einstellung']('kassen')
          kassen[this.neueKasse.name] = this.neueKasse
          this.$store.dispatch('einstellungen/updateEinstellungData', kassen)
          this.istNeu = true
          this.neueKasse = []
        } else {
          console.log('Nicht alle Felder ausgefüllt.')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Kassen.vue?8f586fd4